// extracted by mini-css-extract-plugin
export default {"avatar":"grDBvCgn","imageWrapper":"hHjbcslN","image":"AcMChFXK"};